import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import classnames from 'classnames'

import Image from './../Image'
import TextRenderer from './../TextRenderer'

import PlusIconSvg from './../../graphics/plus-icon.svg'

import styles from './styles.module.scss'

const renderPoints = points => {
    return (
        <div className={styles['product__points']}>
            {points.map(point => {

                const itemClasses = `button ${styles['product-point']} ${styles[`product-point--${point.text_position}`]}`
                
                const buttonClasses = classnames({
                    'button': true,
                    [styles['product-point__button']]: true,
                    [styles['product-point__button--visible']]: point.visible,
                    [styles['product-point__button--inverted']]: point.invert_icon_color,
                    [styles['product-point__button--small']]: point.button_size == 'small'
                })

                return (
                    <SbEditable key={point._uid} content={point}>
                        <div className={`${itemClasses} is-desktop`} style={{ top: `${point.y || 0}%`, left: `${point.x || 0}%` }}>
                            <button className={buttonClasses}>
                                <PlusIconSvg className={styles['product-point__icon']}/>
                            </button>
                            {point.description && <TextRenderer className={styles['product-point__description']} text={point.description} />}
                        </div>
                    </SbEditable>
                )
            })}
        </div>
    )
}

const ProductInformation = (props) => {

    const rowClasses = classnames({
        'row': true,
        [styles['product-information__row']]: true,
        [styles['product-information__row--padding-bottom']]: props.blok.space_at_bottom
    })

	return (
		<SbEditable content={props.blok}>
			<section className={styles['product-information']}>
                <div className='container'>
                    <TextRenderer className={`${styles['product-information__heading']} ${styles['product-information__heading--mobile']}`} text={props.blok.heading} />
                    <div className={rowClasses}>
                        {props.blok.product_elements && props.blok.product_elements.length == 2 && (
                            <>
                                <div className={`col col-12 col-sm-8 ${styles['product-information__col']}`}>
                                    <TextRenderer className={styles['product-information__heading']} text={props.blok.heading} />
                                    {props.blok.product_elements[0] && (
                                        <SbEditable key={props.blok.product_elements[0]._uid} content={props.blok.product_elements[0]}>
                                            <div className={styles['product']}>
                                                {props.blok.product_elements[0].image.filename && (
                                                    <Image blok={props.blok.product_elements[0]} image={props.blok.product_elements[0].image} params={{ maxWidth: 500 }} />
                                                )}
                                                {renderPoints(props.blok.product_elements[0].product_points)}
                                            </div>
                                        </SbEditable>
                                    )}
                                </div>
                                <div className={`col col-8 offset-2 offset-sm-0 col-sm-4 ${styles['product-information__col']}`}>
                                    {props.blok.product_elements[1] && (
                                        <SbEditable key={props.blok.product_elements[1]._uid} content={props.blok.product_elements[1]}>
                                            <div className={styles['product']}>
                                                {props.blok.product_elements[0].image.filename && (
                                                    <Image blok={props.blok.product_elements[1]} image={props.blok.product_elements[1].image} params={{ maxWidth: 500 }} />
                                                )}
                                                {renderPoints(props.blok.product_elements[1].product_points)}
                                            </div>
                                        </SbEditable>
                                    )}
                                </div>
                            </>
                        )}
                        {props.blok.product_elements && props.blok.product_elements.length == 1 && (
                            <>
                                <div className='col col-12'>
                                    <TextRenderer className={styles['product-information__heading']} text={props.blok.heading} />
                                </div>
                                <div className='col col-12 col-sm-2'></div>
                                <div className='col col-8 offset-2 offset-sm-0 col-sm-8'>
                                    {props.blok.product_elements[0] && (
                                        <SbEditable key={props.blok.product_elements[0]._uid} content={props.blok.product_elements[0]}>
                                            <div className={styles['product']}>
                                                {props.blok.product_elements[0].image.filename && (
                                                    <Image blok={props.blok.product_elements[0]} image={props.blok.product_elements[0].image} params={{ maxWidth: 500 }} />
                                                )}
                                                {renderPoints(props.blok.product_elements[0].product_points)}
                                            </div>
                                        </SbEditable>
                                    )}
                                </div>
                                <div className='col col-12 col-sm-2'></div>
                            </>
                        )}
                    </div>
                </div>
            </section>
		</SbEditable>
	)
}

export default ProductInformation